module.exports = __webpack_public_path__ + "img/IMG_6726_L_Wood_MockedUp.ea178337.jpg";